/**
 * Formata um valor numérico para o formato de moeda brasileira (R$ 0,00)
 * ou retorna o valor original se não for um número.
 * @param value - Valor a ser formatado (string ou número)
 * @returns String formatada ou o valor original
 */
export const formatCurrency = (value: string | number): string => {
  if (value === null || value === undefined || value === '') return 'N/A';

  let numValue: number;

  if (typeof value === 'string') {
    // Se a string já contém vírgula, assume-se que é o formato brasileiro "1.234,56"
    if (value.includes(',')) {
      numValue = parseFloat(value.replace(/\./g, '').replace(',', '.'));
    } else {
      // Se não tem vírgula, trata como um número padrão (ex: "1234.56")
      numValue = parseFloat(value);
    }
  } else {
    numValue = value;
  }

  if (isNaN(numValue)) {
    return value.toString();
  }

  return numValue.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });
};

/**
 * Converte um valor monetário (string em formato BR ou número) para number puro.
 * Retorna NaN quando o valor está vazio ou não pode ser interpretado.
 * @param value - Valor a ser convertido (string ou número)
 * @returns Número (ou NaN se inválido/vazio)
 */
export const parseMoneyValue = (value: string | number | undefined | null): number => {
  if (value === null || value === undefined || value === '') return NaN;
  if (typeof value === 'number') return value;

  const cleaned = value.toString().trim();
  if (!cleaned) return NaN;

  const normalized = cleaned.includes(',')
    ? cleaned.replace(/\./g, '').replace(',', '.')
    : cleaned;

  const num = parseFloat(normalized);
  return isNaN(num) ? NaN : num;
};

/**
 * Formata um valor numérico para o formato de número brasileiro (0,00)
 * ou retorna o valor original se não for um número.
 * @param value - Valor a ser formatado (string ou número)
 * @returns String formatada ou o valor original
 */
export const formatNumber = (value: string | number): string => {
  if (value === null || value === undefined || value === '') return 'N/A';

  const numValue = typeof value === 'string' ? parseFloat(value.replace('.', '').replace(',', '.')) : value;

  if (isNaN(numValue)) {
    return value.toString();
  }

  return numValue.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};